module.exports = __webpack_public_path__ + "media/features/use-cases/images/image_tablet_en@2x-842922595a9b5283c126fb653b9ffaf0.png";